(function () {
  'use strict';

  document.querySelectorAll('[data-quantity-selector]').forEach(function (wrap) {
    var input   = wrap.querySelector('[data-qty-input]');
    var minusBtn = wrap.querySelector('[data-qty-minus]');
    var plusBtn  = wrap.querySelector('[data-qty-plus]');
    if (!input) return;

    function getValue() { return parseInt(input.value, 10) || 1; }

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        var val = getValue();
        if (val > 1) { input.value = val - 1; input.dispatchEvent(new Event('change')); }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        input.value = getValue() + 1;
        input.dispatchEvent(new Event('change'));
      });
    }
  });

  function getVariantSelectorData() {
    var select = document.getElementById('lumi-variant-select');
    if (!select) return null;

    var variants = [];

    if (select.tagName === 'SELECT') {
      variants = Array.from(select.options).map(function (opt) {
        return {
          element: opt,
          value: opt.value,
          price: opt.dataset.price,
          compare: opt.dataset.compare,
          options: {
            1: opt.dataset.option1 || '',
            2: opt.dataset.option2 || '',
            3: opt.dataset.option3 || ''
          }
        };
      });
    } else {
      var dataEl = document.getElementById('lumi-variant-data');
      if (dataEl && dataEl.textContent) {
        try {
          variants = JSON.parse(dataEl.textContent).map(function (variant) {
            return {
              value: String(variant.id),
              price: variant.price,
              compare: variant.compare,
              options: {
                1: (variant.options && variant.options['1']) || '',
                2: (variant.options && variant.options['2']) || '',
                3: (variant.options && variant.options['3']) || ''
              }
            };
          });
        } catch (err) {
          variants = [];
        }
      }
    }

    return { select: select, variants: variants };
  }

  function getSelectedVariantValues() {
    var selectedValues = {};
    document.querySelectorAll('[data-variant-option]').forEach(function (p) {
      if (p.classList.contains('is-active')) {
        selectedValues[p.dataset.variantOption] = p.dataset.value;
      }
    });
    return selectedValues;
  }

  function variantMatchesSelection(variant, selectedValues) {
    return Object.keys(selectedValues).every(function (position) {
      return variant.options[position] === selectedValues[position];
    });
  }

  function syncVariantPrice(variant) {
    if (!variant) return;

    var data = getVariantSelectorData();
    if (!data) return;

    data.select.value = variant.value;

    var priceEl = document.getElementById('lumi-price');
    var compareEl = document.getElementById('lumi-compare');

    if (priceEl && variant.price) {
      priceEl.textContent = '$' + (parseInt(variant.price, 10) / 100).toFixed(2);
    }

    if (compareEl && variant.compare) {
      var compare = parseInt(variant.compare, 10);
      var price = parseInt(variant.price, 10);
      if (compare > price) {
        compareEl.textContent = '$' + (compare / 100).toFixed(2);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
  }

  function updateVariantAvailability() {
    var data = getVariantSelectorData();
    if (!data) return;

    document.querySelectorAll('[data-variant-option]').forEach(function (pill) {
      var selectedValues = getSelectedVariantValues();
      selectedValues[pill.dataset.variantOption] = pill.dataset.value;
      var isAvailable = data.variants.some(function (variant) {
        return variantMatchesSelection(variant, selectedValues);
      });

      pill.disabled = !isAvailable;
      pill.classList.toggle('is-disabled', !isAvailable);
    });
  }

  function normalizeActiveVariantPills() {
    var positions = Array.from(new Set(Array.from(document.querySelectorAll('[data-variant-option]')).map(function (pill) {
      return pill.dataset.variantOption;
    })));

    positions.forEach(function (position) {
      var pills = Array.from(document.querySelectorAll('[data-variant-option="' + position + '"]'));
      var active = pills.find(function (pill) {
        return pill.classList.contains('is-active') && !pill.disabled;
      });
      if (active) return;

      var fallback = pills.find(function (pill) { return !pill.disabled; });
      pills.forEach(function (pill) { pill.classList.remove('is-active'); });
      if (fallback) fallback.classList.add('is-active');
    });
  }

  function syncSelectedVariant() {
    var data = getVariantSelectorData();
    if (!data) return;

    var selectedValues = getSelectedVariantValues();
    var selectedVariant = data.variants.find(function (variant) {
      return variantMatchesSelection(variant, selectedValues);
    });

    syncVariantPrice(selectedVariant);
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-variant-option]');
    if (!pill || pill.disabled) return;

    var position = pill.dataset.variantOption;

    document.querySelectorAll('[data-variant-option="' + position + '"]').forEach(function (p) {
      p.classList.remove('is-active');
    });
    pill.classList.add('is-active');

    // Update the selected value display label
    var valueDisplay = document.querySelector('[data-option-value-display="' + position + '"]');
    if (valueDisplay) valueDisplay.textContent = pill.dataset.value;

    updateVariantAvailability();
    normalizeActiveVariantPills();
    updateVariantAvailability();
    syncSelectedVariant();
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateVariantAvailability();
    normalizeActiveVariantPills();
    updateVariantAvailability();
    syncSelectedVariant();
  });
})();
